export default __webpack_public_path__ + "static/media/art-pro-blk-3.a99ae15e.png";